/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(0), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    paginator.$inject = ["mstarDimensions"];
    angular.module('ecPaginator', ['mstarCore', 'ecContainer']).directive('ecPaginator', paginator);

    function paginator(mstarDimensions) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main', {
                preProcessElement: function preProcessElement() {
                    this.removeUnlessSettingIn('.ec-paginator--show-first-and-last', 'showFirstAndLast', [true]);
                    this.removeUnlessSettingIn('.ec-paginator--show-page-numbers', 'showPageNumbers', [true]);
                }
            }),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            mstarComponent.bindParameters(scope);

            // uses elem.find('ec-section') instead of elem in mstarDimensions to fix a bug in Chrome, which returning 0 width and height regardless the actual size
            var mstarDimensionsInstance = mstarDimensions(scope, elem.find('ec-section'));

            if (scope.settings.get('adaptivePagination')) {
                handleDimensionsChange(mstarDimensionsInstance.getDimensions());

                mstarDimensionsInstance.addListener(function (dimensions) {
                    scope.$evalAsync(function () {
                        handleDimensionsChange(dimensions);
                    });
                });
            }

            scope.instance.on('parameterChanged:page', function (newValue) {
                if (newValue < 1) {
                    scope.parameters.page = 1;
                } else if (scope.parameters.lastPage && newValue > scope.parameters.lastPage) {
                    scope.parameters.page = scope.parameters.lastPage;
                }
            });

            scope.$watchCollection('[parameters.totalRows, parameters.perPage, parameters.page, parameters.paginationWindowSize]', function (newValue, oldValue) {
                if (!scope.parameters.perPage || !scope.parameters.totalRows && !oldValue[0]) {
                    return;
                }
                var paginationWindowSize = scope.parameters.paginationWindowSize || scope.parameters.perPage;
                if (paginationWindowSize > scope.parameters.perPage) {
                    scope.logger.error(new Error('paginationWindowSize should not be greater than perPage value.'));
                }
                scope.parameters.lastPage = scope.parameters.totalRows > scope.parameters.perPage ? Math.ceil((scope.parameters.totalRows - scope.parameters.perPage) / paginationWindowSize) + 1 : 1;

                if (scope.parameters.lastPage < scope.parameters.page) {
                    scope.parameters.page = scope.parameters.lastPage || 1;
                }

                scope.pages = getPages();
            });

            scope.setPage = function (page) {

                if (page > scope.parameters.lastPage || page < 1) {
                    return;
                }

                scope.parameters.page = page;
                scope.instance.trigger('ecPaginatorPageChanged', [scope.parameters.page]);
            };

            function handleDimensionsChange(dimensions) {
                if (scope.settings.get('adaptivePagination')) {
                    _.each(scope.settings.get('adaptivePaginationRanges'), function (range) {
                        if (dimensions.width <= range.endPoint && dimensions.width > range.startPoint) {
                            scope.parameters.perPage = range.perPage;
                            return true;
                        }
                    });
                }
            }

            function getPages() {
                var pages = [];
                var numberOfWrappingPageLinks = scope.settings.get('numberOfWrappingPageLinks'),
                    beforeRemaining = Math.min(0, scope.parameters.page - numberOfWrappingPageLinks - 1),
                    afterRemaining = Math.min(0, scope.parameters.lastPage - (scope.parameters.page + numberOfWrappingPageLinks)),
                    start = Math.max(1, scope.parameters.page - numberOfWrappingPageLinks + afterRemaining),
                    end = Math.min(scope.parameters.lastPage, scope.parameters.page + numberOfWrappingPageLinks - beforeRemaining);
                for (var i = start; i <= end; i++) {
                    pages.push(i);
                }

                return pages;
            }

            scope.hasPage = function (page) {
                return scope.getPages().indexOf(page) > -1;
            };
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = {
	"ecPaginator": {
		"labels": {
			"first": {
				"da-DK": "Første",
				"en": "First",
				"en-GB": null,
				"fr": "Premier",
				"it": "Primo",
				"ja": "先頭",
				"sv": "Första",
				"sv-SE": null,
				"zh-CN": "首项",
				"zh-HK": "首項"
			},
			"last": {
				"da-DK": "Sidste",
				"en": "Last",
				"en-GB": null,
				"fr": "Dernier",
				"it": "Ultimo",
				"ja": "最後",
				"sv": "Sista",
				"sv-SE": null,
				"zh-CN": "最后一项",
				"zh-HK": "最後一項"
			},
			"next": {
				"da": "Næste",
				"de": "Nächste",
				"en": "Next",
				"en-GB": null,
				"es": "Siguiente",
				"fr": "Suivant",
				"fr-FR": "Prochain",
				"it": "Avanti",
				"ja": "次へ",
				"sv": "Nästa",
				"sv-SE": null,
				"zh-CN": "下一页",
				"zh-HK": "下一頁"
			},
			"previous": {
				"da": "Forrige",
				"de": "Bisherige",
				"en": "Previous",
				"en-GB": null,
				"es": "Anterior",
				"fr": "Précédent",
				"it": "Indietro",
				"ja": "前へ",
				"sv": "Föregående",
				"sv-SE": null,
				"zh-CN": "上一页",
				"zh-HK": "上一頁"
			}
		},
		"settings": {
			"_parameters": {
				"page": null,
				"paginationWindowSize": {},
				"perPage": null,
				"totalRows": {
					"binding": "{{_ parameters(_).totalRows _}}"
				}
			},
			"_templates": {
				"main": "<ec-section>\r\n    <div data-ng-show=\"parameters.lastPage > 1\">\r\n        <ul class=\"ec-pagination\">\r\n            <li class=\"ec-pagination__item ec-pagination__item--first ec-paginator--show-first-and-last\"\r\n                data-ng-if=\"settings.get('showFirstAndLast')\" data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page == 1 }\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-disabled=\"parameters.page == 1\"\r\n                    data-ng-click=\"setPage(1)\">{{ labels.get('first') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--previous\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': !(parameters.page > 1) }\"\r\n                data-ng-if=\"!settings.get('dynamicPrevNext') || parameters.page > 1\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-disabled=\"!(parameters.page > 1)\"\r\n                    data-ng-click=\"setPage(parameters.page - 1)\">{{\r\n                    labels.get('previous') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--number ec-paginator--show-page-numbers\" data-ng-if=\"settings.get('showPageNumbers')\"\r\n                data-ng-class=\"{ 'ec-pagination__item--active': parameters.page == page }\"\r\n                data-ng-repeat=\"page in pages track by $index\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\" data-ng-click=\"setPage(page)\">{{ page }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--next\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page >= parameters.lastPage}\"\r\n                data-ng-if=\"!settings.get('dynamicPrevNext') || parameters.page < parameters.lastPage\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\"\r\n                    data-ng-click=\"setPage(parameters.page + 1)\">{{\r\n                    labels.get('next') }}</a>\r\n            </li>\r\n            <li class=\"ec-pagination__item ec-pagination__item--last ec-paginator--show-first-and-last\"\r\n                data-ng-if=\"settings.get('showFirstAndLast')\"\r\n                data-ng-class=\"{ 'ec-pagination__item--disabled': parameters.page >= parameters.lastPage }\">\r\n                <a class=\"ec-pagination__link\" href=\"javascript:;\"\r\n                    data-ng-disabled=\"parameters.page >= parameters.lastPage\"\r\n                    data-ng-click=\"setPage(parameters.lastPage)\">\r\n                    {{ labels.get('last') }}</a>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</ec-section>\r\n"
			},
			"adaptivePagination": false,
			"adaptivePaginationRanges": null,
			"dynamicPrevNext": true,
			"numberOfWrappingPageLinks": 5,
			"page": 1,
			"paginationWindowSize": null,
			"perPage": 10,
			"showFirstAndLast": false,
			"showPageNumbers": true,
			"totalRows": null
		},
		"type": "ecPaginator"
	}
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecPaginator', __webpack_require__(2).ecPaginator);
    morningstar.asterix.meta.register('ecPaginator', 'allowedEvents', ['ecPaginatorPageChanged']);
    __webpack_require__(1);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-paginator.js.map


// WEBPACK FOOTER //
// ./components/paginator/build/ec-paginator.js